/**
 * Things that are built and deliberately not offered yet.
 *
 * ONE SWITCH, not a scatter of commented-out JSX. A feature hidden by
 * deleting its markup comes back as a re-implementation; hidden behind a
 * named constant it comes back as a one-word diff, and the tests that prove
 * it works keep running in the meantime.
 *
 * WHAT "HIDDEN" DOES NOT MEAN. These hide CONTROLS. The server routes behind
 * them are still registered and still enforce their own guards — platform
 * admin, a typed confirmation, a mandatory reason. Anyone who can reach the
 * API can still call them. If the intent is that the capability should not
 * exist at all, the routes have to go too; that is a different change and a
 * bigger one.
 */

/**
 * Deleting a club, and deleting a match, from the console.
 *
 * LOCAL DEV ONLY (Ben, 2026-08-30, narrowing the same-day full hide). Both
 * are built and tested, and they are the two most destructive acts the
 * product has — so they show only in a `vite dev` session on a laptop
 * (import.meta.env.DEV), where Ben can watch one happen against a throwaway
 * record. Every SHIPPED build — dev environment included — is a production
 * Vite build, so DEV is false there and the controls stay hidden.
 */
export const DESTRUCTIVE_DELETES_ENABLED = import.meta.env.DEV
